module.exports = __webpack_public_path__ + "img/cross_gray.921cdcae.svg";